(function () {
  const TARGET_CLASS = 'kpo-roman-date-enhanced';
  const PICKER_ROOT_SELECTOR = '.kpo-roman-date-picker';
  const SOURCE_HIDDEN_CLASS = 'kpo-roman-date-picker__source-hidden';
  const HIDDEN_CLASS = 'kpo-roman-date-picker__hidden';
  const FORM_BOUND_KEY = 'kpoRomanDateFormBound';
  const FORM_DATA_BOUND_KEY = 'kpoRomanDateFormDataBound';

  const pickerStates = [];
  let mutationObserver = null;
  let scheduledRefresh = false;
  let pickerId = 0;

  function collectTargets(root) {
    const matches = [];
    if (root && root.nodeType === Node.ELEMENT_NODE && root.classList.contains(TARGET_CLASS)) {
      matches.push(root);
    }

    const scopedRoot = root && root.querySelectorAll ? root : document;
    scopedRoot.querySelectorAll(`.${TARGET_CLASS}`).forEach((element) => {
      matches.push(element);
    });

    return matches;
  }

  function isSupportedInput(field) {
    if (!field || field.disabled) return false;
    if (field.tagName === 'TEXTAREA') return true;
    if (field.tagName !== 'INPUT') return false;

    const type = (field.getAttribute('type') || 'text').toLowerCase();
    return ['date', 'number', 'search', 'tel', 'text'].includes(type);
  }

  function findSourceInput(target) {
    if (!target) return null;
    if (target.matches && target.matches(PICKER_ROOT_SELECTOR)) return null;
    if (isSupportedInput(target)) return target;

    const propertyCandidates = Array.from(
      target.querySelectorAll('input[name^="properties["], textarea[name^="properties["], input[name*="properties["], textarea[name*="properties["]')
    ).filter((field) => {
      if (!isSupportedInput(field)) return false;
      if (field.dataset.kpoRomanDateEnhanced === 'true') return false;
      if (field.closest(PICKER_ROOT_SELECTOR)) return false;
      return true;
    });

    if (propertyCandidates.length > 0) {
      return propertyCandidates[0];
    }

    const descendants = Array.from(target.querySelectorAll('input, textarea')).filter((field) => {
      if (!isSupportedInput(field)) return false;
      if (field.dataset.kpoRomanDateEnhanced === 'true') return false;
      if (field.closest(PICKER_ROOT_SELECTOR)) return false;
      return true;
    });

    return descendants[0] || null;
  }

  function getLabelText(target, sourceInput) {
    const kingOptionLabel = target.querySelector('.ymq-option-title .ymq_lable');
    const kingOptionLabelText = kingOptionLabel ? sanitizeSingleLine(kingOptionLabel.textContent) : '';
    if (kingOptionLabelText) return kingOptionLabelText;

    if (sourceInput.id) {
      try {
        const byFor = document.querySelector(`label[for="${CSS.escape(sourceInput.id)}"]`);
        const byForText = byFor ? sanitizeSingleLine(byFor.textContent) : '';
        if (byForText) return byForText;
      } catch (error) {
        const byForFallback = document.querySelector(`label[for="${sourceInput.id}"]`);
        const byForFallbackText = byForFallback ? sanitizeSingleLine(byForFallback.textContent) : '';
        if (byForFallbackText) return byForFallbackText;
      }
    }

    const scopedLabel = target.closest('label') || target.querySelector('label');
    const scopedLabelText = scopedLabel ? sanitizeSingleLine(scopedLabel.textContent) : '';
    if (scopedLabelText) return scopedLabelText;

    return '';
  }

  function createPickerUi(labelText) {
    pickerId += 1;

    const root = document.createElement('div');
    root.className = 'kpo-roman-date-picker';
    root.dataset.kpoRomanDatePicker = String(pickerId);

    const inputId = `KPORomanDateInput-${pickerId}`;

    const helperLine = document.createElement('p');
    helperLine.className = 'kpo-roman-date-picker__helper';
    helperLine.textContent = 'Type the date in numbers and review the Roman Numerals before adding to cart.';

    const dateInput = document.createElement('input');
    dateInput.type = 'text';
    dateInput.id = inputId;
    dateInput.className = 'kpo-roman-date-picker__input';
    dateInput.autocomplete = 'off';
    dateInput.placeholder = '3.6.2026';
    dateInput.spellcheck = false;
    dateInput.setAttribute('aria-label', labelText || 'Date');

    const romanLabel = document.createElement('div');
    romanLabel.className = `ymq-option-title ${HIDDEN_CLASS}`;

    const romanLabelText = document.createElement('span');
    romanLabelText.className = 'ymq_lable ';
    romanLabelText.textContent = 'Roman Numerals';

    const romanTextSpan = document.createElement('span');
    romanTextSpan.className = 'ymq_option_text_span';

    const romanPriceSpan = document.createElement('span');
    romanPriceSpan.className = 'ymq_option_price_span';

    romanLabel.appendChild(romanLabelText);
    romanLabel.appendChild(romanTextSpan);
    romanLabel.appendChild(romanPriceSpan);

    const romanInput = document.createElement('input');
    romanInput.type = 'text';
    romanInput.readOnly = true;
    romanInput.className = `kpo-roman-date-picker__roman-input ${HIDDEN_CLASS}`;
    romanInput.setAttribute('aria-live', 'polite');

    const errorLine = document.createElement('p');
    errorLine.className = `kpo-roman-date-picker__error ${HIDDEN_CLASS}`;
    errorLine.setAttribute('role', 'alert');

    root.appendChild(helperLine);
    root.appendChild(dateInput);
    root.appendChild(romanLabel);
    root.appendChild(romanInput);
    root.appendChild(errorLine);

    return {
      root,
      dateInput,
      helperLine,
      romanLabel,
      romanInput,
      errorLine,
    };
  }

  function dispatchInputEvents(input) {
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function setSourceValue(state, nextValue) {
    const value = sanitizeSingleLine(nextValue || '');
    if (state.sourceInput.value !== value) {
      state.sourceInput.value = value;
      dispatchInputEvents(state.sourceInput);
    }
    if (state.submitInput && state.submitInput.value !== value) {
      state.submitInput.value = value;
      dispatchInputEvents(state.submitInput);
    }
  }

  function sanitizePropertyLabel(value) {
    return sanitizeSingleLine(value).replace(/[\[\]]+/g, '').trim();
  }

  function getSourcePropertyLabel(sourceInput) {
    const sourceName = sanitizeSingleLine(sourceInput.getAttribute('name'));
    const propertyMatch = sourceName.match(/^properties\[(.*)\]$/);
    if (!propertyMatch) return '';

    return sanitizePropertyLabel(propertyMatch[1]);
  }

  function buildSubmitInputName(sourceInput, labelText) {
    const visibleLabel = sanitizePropertyLabel(labelText);
    const propertyLabel = visibleLabel || getSourcePropertyLabel(sourceInput) || 'Date';
    return `properties[${propertyLabel}]`;
  }

  function findProductForm(sourceInput, target) {
    const sourceForm = sourceInput.closest('form[data-type="add-to-cart-form"]');
    if (sourceForm) return sourceForm;

    const sourceProductForm = sourceInput.closest('product-form');
    if (sourceProductForm) {
      const nestedForm = sourceProductForm.querySelector('form');
      if (nestedForm) return nestedForm;
    }

    const targetProductForm = target.closest('product-form');
    if (targetProductForm) {
      const nestedForm = targetProductForm.querySelector('form');
      if (nestedForm) return nestedForm;
    }

    const productInfoRoot = target.closest('product-info') || sourceInput.closest('product-info');
    if (productInfoRoot) {
      const scopedForm = productInfoRoot.querySelector('form[data-type="add-to-cart-form"]');
      if (scopedForm) return scopedForm;
    }

    return document.querySelector('form[data-type="add-to-cart-form"]');
  }

  function findFirstPropertyField(form, excludeField) {
    if (!form) return null;

    const fields = Array.from(
      form.querySelectorAll(
        'input[name^="properties["], textarea[name^="properties["], select[name^="properties["], input[name*="properties["], textarea[name*="properties["], select[name*="properties["]'
      )
    );

    return (
      fields.find((field) => {
        if (field === excludeField) return false;
        if (!field.name) return false;
        if (field.dataset.kpoRomanDateSubmit === 'true') return false;
        return true;
      }) || null
    );
  }

  function placeSubmitInputFirst(form, submitInput) {
    if (!form || !submitInput) return;

    if (submitInput.parentElement !== form) {
      form.appendChild(submitInput);
    }

    const firstPropertyField = findFirstPropertyField(form, submitInput);
    if (firstPropertyField) {
      let anchor = firstPropertyField;
      while (anchor && anchor.parentElement !== form) {
        anchor = anchor.parentElement;
      }

      if (anchor && anchor.parentElement === form) {
        form.insertBefore(submitInput, anchor);
      } else if (form.firstChild !== submitInput) {
        form.insertBefore(submitInput, form.firstChild);
      }
    } else if (form.firstChild !== submitInput) {
      form.insertBefore(submitInput, form.firstChild);
    }
  }

  function showRomanValue(state, value) {
    state.romanLabel.classList.remove(HIDDEN_CLASS);
    state.romanInput.value = value;
    state.romanInput.classList.remove(HIDDEN_CLASS);
  }

  function clearRomanValue(state) {
    state.romanLabel.classList.add(HIDDEN_CLASS);
    state.romanInput.value = '';
    state.romanInput.classList.add(HIDDEN_CLASS);
  }

  function setError(state, message) {
    state.errorLine.textContent = message;
    state.errorLine.classList.remove(HIDDEN_CLASS);
  }

  function clearError(state) {
    state.errorLine.textContent = '';
    state.errorLine.classList.add(HIDDEN_CLASS);
  }

  function toRoman(number) {
    const values = [
      [1000, 'M'],
      [900, 'CM'],
      [500, 'D'],
      [400, 'CD'],
      [100, 'C'],
      [90, 'XC'],
      [50, 'L'],
      [40, 'XL'],
      [10, 'X'],
      [9, 'IX'],
      [5, 'V'],
      [4, 'IV'],
      [1, 'I'],
    ];

    let remaining = number;
    let result = '';

    values.forEach((entry) => {
      const value = entry[0];
      const numeral = entry[1];
      while (remaining >= value) {
        result += numeral;
        remaining -= value;
      }
    });

    return result;
  }

  function parseRomanDate(value) {
    const cleaned = sanitizeSingleLine(value);
    if (!cleaned) {
      return {
        valid: false,
        value: '',
        empty: true,
      };
    }

    const normalized = cleaned.replace(/[\/\-\s,]+/g, '.').replace(/\.+/g, '.').replace(/^\./, '').replace(/\.$/, '');
    const parts = normalized.split('.');

    if (parts.length !== 3) {
      return {
        valid: false,
        value: '',
        empty: false,
      };
    }

    const romanParts = [];
    for (let index = 0; index < parts.length; index += 1) {
      const part = parts[index];
      if (!/^\d+$/.test(part)) {
        return {
          valid: false,
          value: '',
          empty: false,
        };
      }

      const number = Number.parseInt(part, 10);
      if (!Number.isSafeInteger(number) || number < 1 || number > 3999) {
        return {
          valid: false,
          value: '',
          empty: false,
        };
      }

      romanParts.push(toRoman(number));
    }

    return {
      valid: true,
      value: romanParts.join('.'),
      empty: false,
    };
  }

  function updateStateFromInput(state, showEmptyError) {
    const parsed = parseRomanDate(state.dateInput.value);

    if (parsed.valid) {
      state.isValidSelection = true;
      showRomanValue(state, parsed.value);
      clearError(state);
      setSourceValue(state, parsed.value);
      return true;
    }

    state.isValidSelection = false;
    clearRomanValue(state);
    setSourceValue(state, '');

    if (parsed.empty) {
      if (showEmptyError) {
        setError(state, 'Enter a date before adding to cart.');
      } else {
        clearError(state);
      }
      return false;
    }

    setError(state, 'Enter three date numbers separated by periods, slashes, spaces, or dashes.');
    return false;
  }

  function getCommittedRomanValue(state) {
    if (state.submitInput && !state.submitInput.disabled) return state.submitInput.value;
    if (state.sourceInput) return state.sourceInput.value;
    return '';
  }

  function normalizeCommittedRomanDate(state) {
    const committedValue = getCommittedRomanValue(state);
    if (committedValue && /^[IVXLCDM]+(?:\.[IVXLCDM]+){2}$/i.test(committedValue)) {
      const normalized = committedValue.toUpperCase();
      setSourceValue(state, normalized);
      showRomanValue(state, normalized);
      clearError(state);
      state.isValidSelection = true;
      return true;
    }

    return updateStateFromInput(state, true);
  }

  function isElementVisible(element) {
    if (!element || !element.isConnected) return false;
    if (element.hidden) return false;
    if (element.getAttribute('aria-hidden') === 'true') return false;
    return element.getClientRects().length > 0;
  }

  function clearStateWithoutMessage(state) {
    if (!state) return;
    state.dateInput.value = '';
    state.isValidSelection = false;
    clearRomanValue(state);
    clearError(state);
    setSourceValue(state, '');
  }

  function getStatesForForm(form) {
    return pickerStates.filter((state) => state.form === form && state.sourceInput.isConnected);
  }

  function reorderFormDataProperties(formData, romanEntries) {
    const allEntries = Array.from(formData.entries());
    const propertyEntries = [];

    allEntries.forEach((entry) => {
      const key = String(entry[0] || '');
      if (key.indexOf('properties[') === 0) {
        propertyEntries.push(entry);
      }
    });

    if (propertyEntries.length === 0 && romanEntries.size === 0) return;

    const propertyNames = new Set();
    propertyEntries.forEach((entry) => propertyNames.add(String(entry[0] || '')));
    romanEntries.forEach((value, key) => {
      if (!value) return;
      propertyNames.add(key);
    });

    propertyNames.forEach((name) => formData.delete(name));

    romanEntries.forEach((value, name) => {
      if (!value) return;
      formData.append(name, value);
    });

    propertyEntries.forEach((entry) => {
      const name = String(entry[0] || '');
      if (romanEntries.has(name)) return;
      formData.append(name, entry[1]);
    });
  }

  function bindFormValidation(state) {
    const form = state.form || findProductForm(state.sourceInput, state.target);
    if (!form) return;

    state.form = form;
    placeSubmitInputFirst(form, state.submitInput);
    if (form.dataset[FORM_DATA_BOUND_KEY] !== 'true') {
      form.dataset[FORM_DATA_BOUND_KEY] = 'true';
      form.addEventListener('formdata', (event) => {
        const states = getStatesForForm(form);
        const romanEntries = new Map();
        states.forEach((entry) => {
          if (!entry.submitInput || !entry.submitInput.name) return;
          const normalized = normalizeCommittedRomanDate(entry);
          if (!normalized) return;
          romanEntries.set(entry.submitInput.name, entry.submitInput.value);
        });
        reorderFormDataProperties(event.formData, romanEntries);
      });
    }

    if (form.dataset[FORM_BOUND_KEY] === 'true') return;
    form.dataset[FORM_BOUND_KEY] = 'true';

    form.addEventListener(
      'submit',
      (event) => {
        const states = getStatesForForm(form);
        states.forEach((entry) => {
          if (!entry.form) entry.form = form;
          placeSubmitInputFirst(form, entry.submitInput);
          entry.isValidSelection = normalizeCommittedRomanDate(entry);
        });

        const firstInvalid = states.find((entry) => !entry.isValidSelection);
        if (!firstInvalid) return;

        states.forEach((entry) => {
          if (entry.isValidSelection) return;
          updateStateFromInput(entry, true);
        });

        event.preventDefault();
        event.stopImmediatePropagation();
        firstInvalid.dateInput.focus();
      },
      true
    );
  }

  function bindInputEvents(state) {
    state.dateInput.addEventListener('input', () => {
      updateStateFromInput(state, false);
    });

    state.dateInput.addEventListener('blur', () => {
      if (!state.dateInput.value.trim()) return;
      updateStateFromInput(state, false);
    });
  }

  function enhanceTarget(target) {
    const sourceInput = findSourceInput(target);
    if (!sourceInput) return;
    if (sourceInput.dataset.kpoRomanDateEnhanced === 'true') return;
    sourceInput.dataset.kpoRomanDateEnhanced = 'true';

    const visibleLabelText = getLabelText(target, sourceInput);
    const labelText = visibleLabelText || getSourcePropertyLabel(sourceInput) || 'Date';
    const ui = createPickerUi(labelText);
    const submitInput = document.createElement('input');
    submitInput.type = 'hidden';
    submitInput.name = buildSubmitInputName(sourceInput, visibleLabelText);
    submitInput.dataset.kpoRomanDateSubmit = 'true';
    const productForm = findProductForm(sourceInput, target);

    sourceInput.insertAdjacentElement('afterend', ui.root);
    if (productForm) {
      placeSubmitInputFirst(productForm, submitInput);
    } else {
      ui.root.insertAdjacentElement('afterend', submitInput);
    }

    const state = {
      target,
      root: ui.root,
      sourceInput,
      submitInput,
      dateInput: ui.dateInput,
      helperLine: ui.helperLine,
      romanLabel: ui.romanLabel,
      romanInput: ui.romanInput,
      errorLine: ui.errorLine,
      form: productForm,
      isValidSelection: false,
      originalReadOnly: sourceInput.readOnly,
      originalDisabled: sourceInput.disabled,
      originalTabIndex: sourceInput.getAttribute('tabindex'),
    };

    pickerStates.push(state);

    submitInput.disabled = false;
    sourceInput.disabled = true;
    sourceInput.readOnly = true;
    sourceInput.classList.add(SOURCE_HIDDEN_CLASS);
    sourceInput.setAttribute('tabindex', '-1');
    sourceInput.setAttribute('aria-hidden', 'true');

    const existingValue = sanitizeSingleLine((submitInput.value || sourceInput.value || '').trim());
    if (existingValue && /^[IVXLCDM]+(?:\.[IVXLCDM]+){2}$/i.test(existingValue)) {
      const normalized = existingValue.toUpperCase();
      state.isValidSelection = true;
      showRomanValue(state, normalized);
      setSourceValue(state, normalized);
    } else if (existingValue) {
      state.dateInput.value = existingValue;
      updateStateFromInput(state, false);
    }

    bindInputEvents(state);
    bindFormValidation(state);
  }

  function refresh(root) {
    collectTargets(root).forEach((target) => enhanceTarget(target));
    pickerStates.forEach((state) => {
      if (!state || !state.sourceInput || !state.sourceInput.isConnected) return;
      if (!state.target || !isElementVisible(state.target)) {
        const hasValue = Boolean(sanitizeSingleLine(getCommittedRomanValue(state)));
        if (hasValue || state.isValidSelection || state.dateInput.value.trim()) {
          clearStateWithoutMessage(state);
        }
      }
    });
  }

  function scheduleRefresh() {
    if (scheduledRefresh) return;
    scheduledRefresh = true;
    window.requestAnimationFrame(() => {
      scheduledRefresh = false;
      refresh(document);
    });
  }

  function attachObserver() {
    if (mutationObserver || !document.body) return;

    mutationObserver = new MutationObserver(() => {
      scheduleRefresh();
    });

    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  function sanitizeSingleLine(value) {
    return String(value || '').replace(/[\r\n]+/g, ' ').trim();
  }

  function init() {
    refresh(document);
    attachObserver();
  }

  document.addEventListener('shopify:section:load', (event) => {
    refresh(event.target || document);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
